<template>
    <v-card flat>
        <div class="d-flex px-4 py-4 gap-10 border-bottom">
            <v-select
                v-model="search_category"
                :items="filter"
                item-text="label"
                item-value="value"
                placeholder="Filter"
                outlined
                dense
                hide-details
                style="max-width: 20%"
            ></v-select>

            <v-text-field
                v-model="search_value"
                placeholder="Ketik kata kunci dan tekan enter"
                dense
                outlined
                small
                hide-details
                append-icon="mdi-magnify"
                @keyup.enter="onSearchData(1)"
            ></v-text-field>

            <!-- <v-select
                v-model="search_sort_by"
                :items="sort_by"
                item-text="label"
                item-value="value"
                placeholder="Sort By"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select> -->

            <v-select
                v-model="search_sort_type"
                :items="sort_type"
                item-text="label"
                item-value="value"
                placeholder="Sort Type"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select>
        </div>

        <div class="px-4 py-4 border-bottom">
            <consul-history-rating />
        </div>

        <div class="px-4 py-4">
            <div class="font-size-14 darkgrey--text">Riwayat Konsul</div>
            <div v-for="(history, date) in groupDataHistory" :key="date">
                <v-card flat color="#e1f4fc" class="mt-3">
                    <v-card-text class="px-3 py-2 font-weight-500 black--text">
                        {{ date }}
                    </v-card-text>
                </v-card>

                <div class="mt-3" v-for="(student, i) in history" :key="i">
                    <v-card outlined @click="openDetail(student)">
                        <v-card-text class="px-4 py-3">
                            <div
                                class="d-flex justify-space-between align-center"
                            >
                                <div class="d-flex gap-15 align-center">
                                    <v-avatar>
                                        <v-img
                                            :src="
                                                student.user_image ||
                                                require('@/assets/img/siswa.svg')
                                            "
                                        />
                                    </v-avatar>

                                    <div>
                                        <div
                                            class="font-weight-bold black--text"
                                        >
                                            {{ student.student_name }}
                                        </div>

                                        <div
                                            class="font-size-12"
                                            style="margin-top: -3px"
                                        >
                                            {{ student.subject_name }}
                                        </div>

                                        <div>
                                            <v-rating
                                                :value="student.rating"
                                                color="#ffcf3e"
                                                background-color="#f2f2f2"
                                                empty-icon="$ratingFull"
                                                half-increments
                                                small
                                                readonly
                                                style="margin-left: -10px"
                                            ></v-rating>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-right">
                                    <div class="font-size-12">
                                        {{ student.total_session }} Sesi
                                    </div>
                                    <div class="mt-2">
                                        <v-chip
                                            color="#fbefc9"
                                            text-color="#e2bd4b"
                                            small
                                            class="font-weight-500"
                                        >
                                            {{
                                                $moment(
                                                    student.start_time,
                                                ).format("HH:mm")
                                            }}
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </div>

            <div v-if="Object.keys(groupDataHistory).length === 0">
                <v-card outlined class="mt-3">
                    <v-card-text class="text-center">
                        {{
                            loading
                                ? "Mencari riwayat konsultasi.."
                                : "Riwayat konsultasi tidak ditemukan.."
                        }}
                    </v-card-text>
                </v-card>
            </div>
        </div>

        <app-spinner v-if="loading" />
    </v-card>
</template>

<script>
import ConsulHistoryRating from "./ConsulHistoryRating.vue";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import axios from "axios";

export default {
    name: "consul-history-list",
    components: {
        ConsulHistoryRating,
        AppSpinner,
    },
    data() {
        return {
            loading: false,
            data: [],
            search_category: "student_name",
            search_value: null,
            search_sort_by: "createdAt",
            search_sort_type: "desc",
            params: {
                page: 1,
                limit: 100,
                sort_by: null,
                sort_type: null,
            },
            filter: [
                {
                    value: "student_name",
                    label: "Nama Siswa",
                },
                {
                    value: "subject",
                    label: "Mapel",
                },
            ],
            sort_by: [
                {
                    value: "createdAt",
                    label: "Created Date",
                },
            ],
            sort_type: [
                {
                    value: "asc",
                    label: "Lama ke Baru",
                },
                {
                    value: "desc",
                    label: "Baru ke Lama",
                },
            ],
            totalItems: 0,
        };
    },

    computed: {
        groupDataHistory() {
            return this.groupBy(this.data, "bulan");
        },
    },

    mounted() {
        this.onSearchData(1);
    },

    methods: {
        onSearchData(newPage) {
            this.params = {
                page: newPage || 1,
                limit: 100,
                sort_by: this.search_sort_by || null,
                sort_type: this.search_sort_type || null,
                teacher_id: this.$route.query.teacher_id,
            };

            this.params[this.search_category] = this.search_value;
            this.page = newPage;

            this.fetchData();
        },

        fetchData() {
            const url = `${process.env.API_BASE_URL}konsul/admin/list-konsul`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            axios
                .get(url, {
                    params: this.params,
                    ...options,
                })
                .then(function (response) {
                    self.data = response.data.list_report || [];

                    self.data = self.data.map((e) => {
                        e.bulan = self.$moment(e.date).format("DD MMMM, YYYY");
                        return e;
                    });
                })
                .finally(() => {
                    self.loading = false;
                });
        },

        openDetail(data) {
            this.$router.push({
                path: "/konsul/chat",
                query: { cr_id: data.id },
            });
        },

        groupBy(array, key) {
            const result = {};
            array.forEach((item) => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result;
        },
    },
};
</script>

<style scoped>
.v-rating >>> .v-icon {
    margin-right: -15px !important;
    margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// ConsulHistoryList.vue?322a8cdf